import './index.rb';
import './index.erb';
import './index.module.scss';
import './images/thinking.svg';
import ModalManager from 'utils/modal_manager';

export default class NotSubscribedUserModal {
  constructor($element, resourceRestricted) {
    this.flagValues = $($element).data('flagModalRestriction');
    this.currentResourceRestricted(this.flagValues[resourceRestricted]);
  }

  currentResourceRestricted(flagValues) {
    const { title, description, cta_text, cta_link, btn_text } = flagValues;

    ModalManager.populate('#js-not-subscribed-user-modal', {
      title,
      description,
      cta_text,
      btn_text
    });

    ModalManager.open('#js-not-subscribed-user-modal');
    this.createLink(cta_link);
  }

  createLink(link) {
    $('a.not-subscribed-user-modal-btn').attr('href', link);
  }
}
